import Update from '../update/index';

function updateCubeList(cubeIds: CubeId[]): void {
    Update.updateCubeList(cubeIds);
    Update.updateEnd();
}

export {
    updateCubeList
};
